import styled from '@emotion/styled';
import { AuthField } from './AuthField';
import { Headers } from './Headers';
import { QueryParams } from './QueryParams';
import { UrlField } from './UrlField';

const FormContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
`;

interface Props {
    mode: 'edit' | 'create';
}

export const FormContent = ({ mode }: Props) => {
    return (
        <FormContentContainer>
            <UrlField />
            <AuthField mode={mode} />
            <Headers />
            <QueryParams />
        </FormContentContainer>
    );
};
